export const isValidUrl = (url: string): boolean => {
  const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  return urlRegex.test(url);
};

export const isSafeUrl = (url: string): boolean => {
  const dangerousCharacters = /['"<>;]/;
  return !dangerousCharacters.test(url);
};
